import React from 'react';
import { useNavigate } from 'react-router-dom';
import { RED, BLACK } from '../components/Layout';

export const SuccessPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div style={{ padding: '80px 40px', textAlign: 'center', maxWidth: 600, margin: '0 auto' }}>
      <div style={{ fontSize: 48, marginBottom: 24 }}>🎸</div>
      <h1 style={{ fontWeight: 900, fontStyle: 'italic', fontSize: '2.5rem', color: BLACK, marginBottom: 16 }}>Thank you!</h1>
      <div style={{ width: 40, height: 3, background: RED, margin: '0 auto 24px' }} />
      <p style={{ fontSize: 15, lineHeight: 1.7, color: 'rgba(0,0,0,0.6)', marginBottom: 32 }}>
        Your order has been placed successfully. You will receive a confirmation email shortly. If you have any questions, call us on <strong>056 776 5693</strong>.
      </p>
      <button onClick={() => navigate('/shop')} style={{ background: RED, color: 'white', border: 'none', padding: '14px 32px', fontWeight: 700, fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.14em', cursor: 'pointer', marginRight: 12 }}>
        Continue Shopping
      </button>
      <button onClick={() => navigate('/')} style={{ background: 'none', color: 'rgba(0,0,0,0.5)', border: '1px solid rgba(0,0,0,0.2)', padding: '14px 32px', fontWeight: 700, fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.14em', cursor: 'pointer' }}>
        Back to Home
      </button>
    </div>
  );
};
